export class CheckinRequest {
    WorkerID: String;
    FirstName: String;
    LastName: String;
    Organization: String;
    SiteID: String;
    VisitReason: String;
    PhoneNumber: String;
}